import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { DeletePairAssignmentsInput_InputAdapter_instance2vt9pds940brw as DeletePairAssignmentsInput_InputAdapter_instance } from '../type/adapter/DeletePairAssignmentsInput_InputAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DeletePairAssignmentsMutation_VariablesAdapterClass;
function DeletePairAssignmentsMutation_VariablesAdapter() {
  if (DeletePairAssignmentsMutation_VariablesAdapterClass === VOID) {
    class $ {
      j6f(writer, value, customScalarAdapters, withDefaultValues) {
        writer.q47('input');
        obj(DeletePairAssignmentsInput_InputAdapter_instance).o3z(writer, customScalarAdapters, value.i6f_1);
      }
    }
    initMetadataForObject($, 'DeletePairAssignmentsMutation_VariablesAdapter');
    DeletePairAssignmentsMutation_VariablesAdapterClass = $;
  }
  return DeletePairAssignmentsMutation_VariablesAdapterClass;
}
var DeletePairAssignmentsMutation_VariablesAdapter_instance;
function DeletePairAssignmentsMutation_VariablesAdapter_getInstance() {
  return DeletePairAssignmentsMutation_VariablesAdapter_instance;
}
//region block: init
DeletePairAssignmentsMutation_VariablesAdapter_instance = new (DeletePairAssignmentsMutation_VariablesAdapter())();
//endregion
//region block: exports
export {
  DeletePairAssignmentsMutation_VariablesAdapter_instance as DeletePairAssignmentsMutation_VariablesAdapter_instance2a4v59l4sghc6,
};
//endregion

//# sourceMappingURL=DeletePairAssignmentsMutation_VariablesAdapter.mjs.map
